<template>
  <div class="training-plan">
    <el-card class="box-card">
      <h2>我的培训计划</h2>
      <el-table :data="trainingPlans" border style="width: 100%">
        <!-- 计划名称 -->
        <el-table-column prop="planName" label="计划名称" width="300">
          <template #default="scope">
            <span>{{ scope.row.planName }}</span>
            <el-tag v-if="scope.row.isNew" type="success" effect="dark" class="new-tag">
              新
            </el-tag>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column prop="status" label="状态" width="120">
          <template #default="scope">
            <el-tag :type="statusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>

        <!-- 开始时间 -->
        <el-table-column prop="startDate" label="开始时间"></el-table-column>

        <!-- 截止时间 -->
        <el-table-column prop="endDate" label="截止时间"></el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button
                v-if=" scope.row.status === '进行中'"
                type="primary"
                size="small"
                @click="startPlan(scope.row.planId)"
            >
              开始学习
            </el-button>
            <el-button
                v-if="scope.row.status === '已完成'"
                type="success"
                size="small"
                @click="startPlan(scope.row.planId)"
            >
              开始学习
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from "../axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      trainingPlans: [], // 当前显示的培训计划
      refreshInterval: null, // 定时器引用
      cacheKey: "trainingPlansCache", // LocalStorage 缓存键名
    };
  },
  created() {
    this.fetchTrainingPlans();

    // 定期轮询获取培训计划
    this.refreshInterval = setInterval(() => {
      this.fetchTrainingPlans();
    }, 30000); // 每 30 秒更新一次
  },
    beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    // 从后端获取培训计划数据
    fetchTrainingPlans() {
      axios
          .get("/XY/plan", { params: { UserID: this.userid } })
          .then((response) => {
            const newPlans = response.data.data || [];
            this.checkForChanges(newPlans);
            this.trainingPlans = newPlans;

            // 遍历数据动态设置状态
            const currentDate = new Date();
            this.trainingPlans.forEach((plan) => {
              const startDate = new Date(plan.startDate);
              const endDate = new Date(plan.endDate);

              if (currentDate < startDate) {
                plan.status = "未开始";
              } else if (currentDate >= startDate && currentDate <= endDate) {


                if(plan.status===1){
                  plan.status = "已完成";
                }
                else
                plan.status = "进行中";
              } else {
                plan.status = "已结束";
              }
            });
          })
          .catch((error) => {
            console.error("获取培训计划数据失败", error);
            this.$message.error("获取培训计划数据失败");
          });
    },

    // 检查数据变化并更新缓存
    checkForChanges(newPlans) {
      const cachedPlans = this.getCachedPlans();
      const cachedPlanIds = cachedPlans.map((plan) => plan.planId);

      // 检测新增计划
      newPlans.forEach((plan) => {
        if (!cachedPlanIds.includes(plan.planId)) {
          plan.isNew = true; // 新增计划标记为新
        }
      });

      // 更新缓存
      this.setCachedPlans(newPlans);
    },

    // 获取缓存中的计划
    getCachedPlans() {
      const cached = localStorage.getItem(this.cacheKey);
      return cached ? JSON.parse(cached) : [];
    },

    // 更新缓存
    setCachedPlans(plans) {
      localStorage.setItem(this.cacheKey, JSON.stringify(plans));
    },

    // 点击“开始学习”按钮时的处理逻辑
    startPlan(planId) {
      this.$router.push({
        name: "VideoPlay",
        query: {
          planId: planId,
          userid: this.userid,
          organizationID: this.organizationID,
        },
      });
    },

    // 根据状态返回对应的标签颜色
    statusType(status) {
      if (status === "未开始") return "warning";
      if (status === "进行中") return "primary";
      if (status === "已完成") return "success";
    },
  },
};
</script>

<style scoped>
.training-plan {
  padding: 20px;
}
.new-tag {
  margin-left: 5px;
}
</style>
